module.exports = __webpack_public_path__ + "img/marisa kirisame witch of scarlet dreams_sc1.ec9725ce.png";